export default {"src":"/_next/static/media/personalData.fa9ffdeb.svg","height":315,"width":703,"blurWidth":0,"blurHeight":0};